import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M4.052 2.595a9 9 0 0 0-1.426 1.537q.385.14.813.431c1.795 1.219 3.61 1.219 5.187-.048.866-.695 1.718-.695 2.813.048 1.795 1.219 3.61 1.219 5.187-.048.866-.695 1.718-.695 2.813.048 1.795 1.219 3.61 1.219 5.187-.048.866-.695 1.718-.695 2.813.048.935.635 1.876.94 2.786.906-.526-.992-1.316-2.116-2.472-3.027-1.526-.724-3.038-.563-4.379.514-.866.695-1.718.695-2.812-.048-1.796-1.219-3.61-1.219-5.188.048-.866.695-1.718.695-2.812-.048-1.796-1.219-3.61-1.219-5.188.048-.866.695-1.718.695-2.812-.048a6 6 0 0 0-.51-.313M.53 9.485q.145-.804.336-1.61s.074-.35.266-.898c1.105-.24 2.271.038 3.43.824 1.094.743 1.946.743 2.812.048 1.578-1.266 3.392-1.266 5.188-.048 1.094.743 1.946.743 2.812.048 1.577-1.266 3.392-1.266 5.188-.048 1.094.743 1.946.743 2.812.048 1.578-1.266 3.392-1.266 5.188-.048 1.015.69 1.822.74 2.624.188q.242 1.026.405 2.056c-1.312.575-2.738.371-4.152-.589-1.095-.742-1.947-.742-2.813-.047-1.577 1.266-3.392 1.266-5.187.047-1.095-.742-1.947-.742-2.813-.047-1.577 1.266-3.392 1.266-5.187.047-1.095-.742-1.947-.742-2.813-.047-1.577 1.266-3.392 1.266-5.187.047-1.095-.742-1.947-.742-2.813-.047zm-.374 2.743c-.083.877-.13 1.738-.148 2.57l.618-.496c.866-.695 1.718-.695 2.813.048 1.795 1.218 3.61 1.218 5.187-.048.866-.695 1.718-.695 2.813.048 1.795 1.218 3.61 1.218 5.187-.048.866-.695 1.718-.695 2.813.048 1.795 1.218 3.61 1.218 5.187-.048.866-.695 1.718-.695 2.813.048 1.56 1.058 3.134 1.197 4.554.386-.015-.78-.054-1.58-.123-2.391l-.496.397c-.866.695-1.718.695-2.812-.047-1.796-1.219-3.61-1.219-5.188.047-.866.695-1.718.695-2.812-.047-1.796-1.219-3.61-1.219-5.188.047-.866.695-1.718.695-2.812-.047-1.796-1.219-3.61-1.219-5.188.047-.866.695-1.718.695-2.812-.047-1.506-1.022-3.025-1.187-4.406-.467m-.028 7.367a36 36 0 0 1-.122-2.392c1.421-.813 2.995-.674 4.556.385 1.094.743 1.946.743 2.812.048 1.578-1.267 3.392-1.267 5.188-.048 1.094.743 1.946.743 2.812.048 1.577-1.267 3.392-1.267 5.188-.048 1.094.743 1.946.743 2.812.048 1.578-1.267 3.392-1.267 5.188-.048 1.094.743 1.946.743 2.812.048l.62-.497a35 35 0 0 1-.143 2.568c-1.383.723-2.904.56-4.412-.464-1.095-.743-1.947-.743-2.813-.048-1.577 1.267-3.392 1.267-5.187.048-1.095-.743-1.947-.743-2.813-.048-1.577 1.267-3.392 1.267-5.187.048-1.095-.743-1.947-.743-2.813-.048-1.577 1.267-3.392 1.267-5.187.048-1.095-.743-1.947-.743-2.813-.048zm.282 2.297q.165 1.025.412 2.051c.8-.545 1.605-.493 2.617.193 1.795 1.22 3.61 1.22 5.187-.047.866-.695 1.718-.695 2.813.047 1.795 1.22 3.61 1.22 5.187-.047.866-.695 1.718-.695 2.813.047 1.795 1.22 3.61 1.22 5.187-.047.866-.695 1.718-.695 2.813.047 1.166.792 2.34 1.07 3.452.82a8 8 0 0 0 .243-.832q.2-.841.348-1.682l-.108.087c-.866.695-1.718.695-2.812-.048-1.796-1.218-3.61-1.218-5.188.048-.866.695-1.718.695-2.812-.048-1.796-1.218-3.61-1.218-5.188.048-.866.695-1.718.695-2.812-.048-1.796-1.218-3.61-1.218-5.188.048-.866.695-1.718.695-2.812-.048-1.414-.96-2.84-1.163-4.152-.589m1.35 4.578c.489.942 1.217 2.017 2.275 2.919 1.598.844 3.189.72 4.592-.407.866-.695 1.718-.695 2.813.048 1.795 1.218 3.61 1.218 5.187-.048.866-.695 1.718-.695 2.813.048 1.795 1.218 3.61 1.218 5.187-.048.866-.695 1.718-.695 2.813.048q.276.187.553.337a9 9 0 0 0 1.418-1.549 3.7 3.7 0 0 1-.848-.443c-1.796-1.219-3.61-1.219-5.188.047-.866.695-1.718.695-2.812-.047-1.796-1.219-3.61-1.219-5.188.047-.866.695-1.718.695-2.812-.047-1.796-1.219-3.61-1.219-5.188.047-.866.695-1.718.695-2.812-.047-.942-.64-1.888-.943-2.803-.905",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.875 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#9C3900", d: "M23.276 8.602 23.07 28.27c0 1.035.936 1.035 1.036 0L23.898 8.6z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      d: "M17.82 7.469c.933-.714 2.942-.685 4.398.199-.178-1.527-.06-3.276.532-4.213 1.703.683 2.037 2.738 1.847 4.463q.636-1.447 1.082-1.858c1.677-1.545 3.23-.477 3.215-.287-.571.083-1.17.987-1.81 1.975 1.063-.174 2.476.425 2.64 1.51-.634-.12-1.36.197-2.166.588q.489.172.882.469 1.65 1.24.63 3.42a10 10 0 0 0-2.336-1.93 25 25 0 0 0-.672-.385q1.153 1.81.212 4.024c-1.046-1.612-2.377-2.549-3.029-3.527q-1.009 2.73-4.156 2.475-.009-1.85 2.036-3.01c-1.468.061-3.025.181-4.209.715q.966-2.841 4.417-2.227-1.059-1.466-3.513-2.401"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#D9D9D9", d: "m21.237 22.411 2.412-.432 2.512.432-1.166.485-2.15.035z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M23.667 18a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M26.635 20.596c1.098-1.266 1.222-2.451.265-3.095-.39-.262-.95-.306-1.761-.232-.182.017-.364.038-.608.07-.695.09-.725.094-.87.094-.142 0-.166-.002-.864-.094a15 15 0 0 0-.612-.07c-.807-.074-1.367-.029-1.756.232-.957.644-.833 1.829.265 3.095l.262.302.605-.525-.263-.302c-.824-.95-.89-1.59-.422-1.906.183-.123.608-.157 1.236-.1.17.016.345.036.58.067.773.101.773.101.97.101.198 0 .206 0 .973-.1.235-.031.408-.052.577-.067.631-.058 1.058-.024 1.242.1.468.314.401.955-.423 1.905l-.262.302.604.525z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M26.484 20.464c1.03-1.186 1.14-2.235.305-2.797-.338-.227-.866-.27-1.632-.199a16 16 0 0 0-.6.07c-.713.093-.737.095-.895.095-.156 0-.174-.002-.891-.096a15 15 0 0 0-.604-.07c-.763-.069-1.289-.026-1.626.2-.835.562-.725 1.61.304 2.797l.131.152.303-.263-.132-.15c-.892-1.03-.973-1.807-.383-2.204.235-.157.693-.194 1.366-.133.174.016.35.037.589.068.753.099.76.1.943.1.185 0 .198-.002.947-.1.237-.031.412-.052.585-.068.676-.062 1.136-.025 1.372.133.59.397.509 1.174-.384 2.203l-.13.151.301.262z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M20.667 20s.722-1.33 3-1.333 3 1.333 3 1.333v2h-6z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m20.667 20 1 1.333.466-1.666L23 21l.666-1.605.667 1.605.867-1.333.466 1.666 1-1.333v2.667h-6z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M23.667 23.333c1.656 0 3-.298 3-.666s-1.344-.667-3-.667c-1.657 0-3 .299-3 .667s1.343.666 3 .666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M23.466 17.878v1.433a.2.2 0 0 0 .4 0v-1.433a.2.2 0 0 0-.4 0" })
);
var SvgFlagIot = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagIot_default = SvgFlagIot;

export { FlagIot_default as default };
